module.exports = __webpack_public_path__ + "media/public/fonts/QanelasMedium/QanelasMedium-6f9eba1edc676a01060193e40236fb90.ttf";